import React, { Component, Fragment } from 'react'
import AddIcon from '../../resources/addIcon@3x.png'
import TextField from '@material-ui/core/TextField'
import { Flex, Box } from 'reflexbox'
import { EmergencySelectedText, HealtheraButton, Icon, SubHeader, UnorderedList, List, TextButton } from '../../healtheraComponents'
import * as yup from 'yup'
import DynamicDialog from '../DynamicDialog/DynamicDialog'

export default class Login extends Component {

  state = {
    removeMember: {},
    removeDialog: false,
    teamMember: '',
  }

  handleTeamMemberChange(key, e) { this.setState({ [key]: e.target.value.trim() }) }

  addTeamMember() {
    const { teamMember } = this.state
    const { branchID } = this.props
    const validateEmail = yup.string().email().required()
    validateEmail.isValid(teamMember).then(async (valid) => {
      if (valid) {
        await this.props.updateBranch(branchID, { teamMember })
        await this.props.getBranch(branchID)
        this.setState({ teamMember: '' })
      } else {
        alert('please enter valid email')
      }
    })
  }

  async removeTeamMember(teamMemberID) {
    const { branchID } = this.props
    await this.props.removeTeamMember(branchID, teamMemberID)
    await this.props.getBranch(branchID)
    this.handleDialog()
  }

  handleDialog(member) {
    let { removeDialog } = this.state
    this.setState({ removeMember: member ? member : {}, removeDialog: !removeDialog })
  }

  render() {
    const { members } = this.props
    const { removeMember, removeDialog, teamMember } = this.state
    return (
      <Fragment>
        <Box pr={4}>
          <SubHeader title='Team Members' />
          {members && members.length > 0 && members.map((member, i) => {
            return (
              <Fragment key={i}>
                <UnorderedList>
                  <span>{member.username}</span>
                  {member.status === 'pending' && <TextButton cursor={`unset`} color={`#2f9d6d`} float={`right`}>Invited</TextButton>}
                  {member.status !== 'pending' && <TextButton color={`#d0021b`} float={`right`} onClick={this.handleDialog.bind(this, member)}>Remove</TextButton>}
                  <List />
                </UnorderedList>
                <DynamicDialog open={removeDialog} title={'Removing Team Member'} contentText={contentText(removeMember.username)} actions={DialogButtons(this.handleDialog.bind(this), this.removeTeamMember.bind(this, removeMember._id))} />
              </Fragment>
            )
          })}
          <TextField
            label='Email'
            onChange={this.handleTeamMemberChange.bind(this, 'teamMember')}
            margin='normal'
            fullWidth
            value={teamMember}
          />
          {teamMember && <Flex align={'center'}>
            <Box>
              <Icon cursor={`pointer`} width={`29px`} src={AddIcon} alt='Add team member' />
            </Box>
            <Box p={2}>
              <TextButton color={`#2f9d6d`} onClick={this.addTeamMember.bind(this)}>Add new team member</TextButton>
            </Box>
          </Flex>}
        </Box>
      </Fragment>
    )
  }
}

const DialogButtons = (buttonOne, buttonTwo) => {
  return (
    <Fragment>
        <HealtheraButton onClick={buttonOne} margin={'0 10px 5px'} height={'32px'} width={'95px'} color="primary">
          Cancel
        </HealtheraButton>
        <HealtheraButton onClick={buttonTwo} margin={'0 10px 5px'} height={'32px'} width={'95px'} background={'#d0021b'} color="primary">
          Remove
        </HealtheraButton>
    </Fragment>
  )
}

const contentText = (user) => {
  return (
    <Fragment> By clicking the remove button, <EmergencySelectedText> {user} </EmergencySelectedText> will be removed from the branch and lose all access. Please decide carefully before proceeding. </Fragment>

  )
}
